import _regeneratorRuntime from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CommonMixin from "@/core/plugins/common-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ServiceMixin from "@/core/plugins/product-mixin";
import { POST, GET, PUT, CLEAR_ERROR, UPDATE_ERROR } from "@/core/services/store/request.module";
import ServiceCreate from "@/view/pages/service/partials/Create.vue";
export default {
  mixins: [CommonMixin, ServiceMixin],
  name: "service-create",
  title: "Create Service",
  data: function data() {
    return {
      barcode: null,
      barcodeDialog: false,
      barcodeSetting: {
        prefix_string: null,
        next_number: null,
        number_length: null
      },
      serviceCreate: null,
      serviceId: null,
      duplicateId: null
    };
  },
  components: {
    ServiceCreate: ServiceCreate
  },
  beforeUpdate: function beforeUpdate() {
    this.$store.dispatch(CLEAR_ERROR);
  },
  methods: {
    updateService: function updateService(param) {
      this.serviceCreate = param;
    },
    getService: function getService(serviceId) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (serviceId && serviceId > 0) {
          _this.$store.dispatch(GET, {
            url: "service/" + serviceId
          }).then(function (response) {
            resolve(response.data);
          }).catch(function (error) {
            reject(error);
          });
        } else {
          resolve({});
        }
      });
    },
    createWarrantyEntity: function createWarrantyEntity() {
      var _this = this;

      return new Promise(function (resolve) {
        var warrantyFormData = _this.lodash.compact(_this.lodash.map(_this.serviceCreate.warranty, function (param) {
          if (param.field && param.value) {
            return param;
          }
        }));

        if (_this.lodash.isEmpty(warrantyFormData) === false) {
          _this.formLoading = true;

          _this.$store.dispatch(POST, {
            url: "product/" + _this.serviceId + "/entity",
            data: {
              type: 1,
              entities: warrantyFormData
            }
          }).then(function () {
            resolve(true);
          }).catch(function (error) {
            _this.logError(error);
          }).finally(function () {
            _this.formLoading = false;
          });
        } else {
          resolve(true);
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this = this;

      if (!_this.$refs.serviceForm.validate()) {
        return false;
      }

      _this.formLoading = true;

      _this.$store.dispatch(CLEAR_ERROR, {});

      var requestType = POST;
      var requestURL = "service";

      if (_this.serviceId && _this.serviceId > 0) {
        requestType = PUT;
        requestURL = "service/" + _this.serviceId;
      }

      _this.$store.dispatch(requestType, {
        url: requestURL,
        data: _this.serviceCreate
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.serviceId = response.data ? response.data.id : null;
                  _context.next = 3;
                  return _this.createWarrantyEntity();

                case 3:
                  _this.$router.push(_this.getDefaultRoute("service", {
                    query: {
                      status: "all"
                    }
                  }));

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.formLoading = false;
      });
    },
    loadContent: function loadContent() {
      var _this = this;

      _this.getService(_this.serviceId).then(function (response) {
        if (_this.lodash.isEmpty(response) === false) {
          _this.$store.dispatch(SET_BREADCRUMB, [{
            title: "Service",
            route: "service"
          }, {
            title: "Update"
          }]);

          _this.barcode = response.barcode;
          var categoryId = null;

          if (response.category) {
            categoryId = response.category.id;
          }

          _this.serviceCreate = {
            name: response.name,
            reference: response.reference,
            description: response.description,
            category: categoryId,
            product_type: response.product_type,
            images: response.images,
            product_images: response.product_images,
            sellable: response.is_sellable,
            confirmed: response.is_confirmed,
            tax: response.tax ? response.tax.id : null,
            tax_exemption: response.tax_exemption ? response.tax_exemption.id : null,
            taxable: response.is_taxable,
            charges: response.charges,
            warranty: _this.lodash.compact(_this.lodash.map(response.warranty_data, function (param) {
              if (param.field && param.value) {
                return {
                  id: param.id,
                  field: param.field,
                  value: param.value
                };
              }
            }))
          };
        }
      }).catch(function (error) {
        _this.$store.dispatch(UPDATE_ERROR, error);
      });
    },
    loadDuplicateContent: function loadDuplicateContent() {
      var _this = this;

      _this.getService(_this.duplicateId).then(function (response) {
        if (_this.lodash.isEmpty(response) === false) {
          _this.barcode = response.barcode;
          _this.serviceCreate = {
            name: response.name,
            reference: response.reference,
            description: response.description,
            category: response.category.id,
            product_type: response.product_type,
            images: response.images,
            // product_images: response.product_images,
            sellable: response.is_sellable,
            confirmed: response.is_confirmed,
            tax: response.tax ? response.tax.id : null,
            tax_exemption: response.tax_exemption ? response.tax_exemption.id : null,
            taxable: response.is_taxable,
            charges: response.charges,
            warranty: _this.lodash.compact(_this.lodash.map(response.warranty_data, function (param) {
              if (param.field && param.value) {
                return {
                  id: param.id,
                  field: param.field,
                  value: param.value
                };
              }
            }))
          };
        }
      }).catch(function (error) {
        _this.$store.dispatch(UPDATE_ERROR, error);
      });
    }
  },
  created: function created() {
    var _this = this;

    _this.serviceId = _this.lodash.toSafeInteger(_this.$route.params.id);
    _this.duplicateId = _this.lodash.toSafeInteger(_this.$route.query.duplicate);
  },
  mounted: function mounted() {
    var _this = this;

    _this.$store.dispatch(SET_BREADCRUMB, [{
      title: "Service",
      route: "service"
    }, {
      title: "Create"
    }]);

    if (_this.$route.name == "admin.service.update" || _this.$route.name == "engineer.service.update") {
      _this.updateMode = true;

      if (_this.serviceId <= 0) {
        _this.$router.go(-1);
      }

      _this.loadContent();
    }

    if (_this.duplicateId > 0) {
      _this.loadDuplicateContent();
    }
  }
};